import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { Wrapper } from 'modules/Roles/ViewRole/CollegesTable/CollegeFilter/Styles/style'

const DriveStatusFilter = ({ driveStatusValue, setDriveStatusValue }) => {
  const tierOptions = [
    {
      label: 'Pending',
      value: 'PENDING',
    },
    {
      value: 'REQUESTED',
      label: 'Requested',
    },
    {
      value: 'CONFIRMED',
      label: 'Confirmed',
    },
    {
      value: 'RESCHEDULE_REQUESTED',
      label: 'Reschedule Requested',
    },
    {
      value: 'CANCELLED',
      label: 'Cancelled',
    },
    {
      value: 'COMPLETED',
      label: 'Completed',
    },
    {
      value: 'ONGOING',
      label: 'Ongoing',
    },
  ]

  return (
    <Wrapper column>
      <FilterCheckBoxComp
        value={driveStatusValue}
        options={tierOptions}
        onChange={values => setDriveStatusValue([values[values?.length - 1]])}
      />
    </Wrapper>
  )
}

export default DriveStatusFilter
